export default "__VITE_ASSET__BlXEWXEN__"